import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { playSound as _playSound } from 'flow/actions/sounds-actions';
import { getFaro } from 'flow/api-clients/faro-client';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import AppContext from 'flow/contexts/app-context';
import { addGeneralLogEntry, errorMessageIsPlayRequestInterrupted } from 'flow/utils/browser-utils';
import { twMerge } from 'tailwind-merge';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var BaseAudioPlayer = /*#__PURE__*/function (_React$PureComponent) {
  function BaseAudioPlayer(props) {
    var _this;
    _classCallCheck(this, BaseAudioPlayer);
    _this = _callSuper(this, BaseAudioPlayer, [props]);

    /* Set props.duration for DTO files related to voicemails and recorded calls since we can't rely on
     * the Content-Length in the header request.
     */
    _defineProperty(_this, "play", function (event) {
      var duration = _this.state.duration;
      var currentTime = _this._audio.currentTime;
      var _this$props = _this.props,
        playSound = _this$props.playSound,
        onPlay = _this$props.onPlay;
      playSound === null || playSound === void 0 || playSound(_this.props.uniqueId);
      event === null || event === void 0 || event.stopPropagation();
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.audio-player-pause')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pauseButton = _step.value;
          pauseButton.click();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (currentTime >= duration) {
        _this.updateCurrentTime(0);
      }
      var playPromise = _this._audio.play();
      if (playPromise instanceof Promise) {
        playPromise.then(function () {
          _this.setState({
            isPlaying: true
          });
          if (onPlay) {
            onPlay();
          }
        })["catch"](function (error) {
          var _getFaro;
          //Catching promise error to silence following error:
          //"AbortError: The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22"
          console.error(error);
          if (errorMessageIsPlayRequestInterrupted(error)) {
            return;
          }
          (_getFaro = getFaro()) === null || _getFaro === void 0 || _getFaro.api.pushError(error);
          addGeneralLogEntry("Error reported: ".concat(error));
        });
      } else {
        _this.setState({
          isPlaying: true
        });
        if (onPlay) {
          onPlay();
        }
      }
    });
    _defineProperty(_this, "pause", function (event) {
      event === null || event === void 0 || event.stopPropagation();
      _this._audio.pause();
      _this.setState({
        isPlaying: false
      });
    });
    _defineProperty(_this, "stop", function (event) {
      event === null || event === void 0 || event.stopPropagation();
      _this._audio.pause();
      _this.updateCurrentTime(0);
      _this.setState({
        isPlaying: false
      });
    });
    _defineProperty(_this, "updateCurrentTime", function (value) {
      _this._audio.currentTime = value;
    });
    _defineProperty(_this, "setDuration", function () {
      _this.setState({
        duration: _this._audio.duration
      });
    });
    _this.state = {
      isPlaying: false,
      onPlayerHead: false,
      duration: props.duration,
      leftPosition: 0,
      currentTime: 0
    };
    return _this;
  }
  _inherits(BaseAudioPlayer, _React$PureComponent);
  return _createClass(BaseAudioPlayer);
}(React.PureComponent);
_defineProperty(BaseAudioPlayer, "propTypes", {
  url: PropTypes.string.isRequired,
  downloadUrl: PropTypes.string,
  duration: PropTypes.number,
  downloadable: PropTypes.bool,
  uniqueId: PropTypes.string,
  //voicemail uniqueId
  onPlay: PropTypes.func,
  playSound: PropTypes.func
});
_defineProperty(BaseAudioPlayer, "contextType", AppContext);
_defineProperty(BaseAudioPlayer, "defaultProps", {
  duration: 0
});
var AudioPlayer = /*#__PURE__*/function (_BaseAudioPlayer2) {
  function AudioPlayer() {
    var _this2;
    _classCallCheck(this, AudioPlayer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AudioPlayer, [].concat(args));
    _defineProperty(_this2, "timeUpdate", function () {
      var duration = _this2.state.duration;
      var currentTime = _this2._audio.currentTime;
      var timelineWidth = _this2.getTimelineWidth();
      var positionFromLeft = timelineWidth * (currentTime / duration);
      _this2.setPlayerHeadPosition(positionFromLeft);
      if (currentTime >= duration) {
        _this2.pause();
      }
    });
    _defineProperty(_this2, "getTimelineWidth", function () {
      var timelineOffsets = _this2._timeLine.getBoundingClientRect();
      var playerHeadOffsets = _this2._playerHead.getBoundingClientRect();
      return timelineOffsets.width - playerHeadOffsets.width;
    });
    _defineProperty(_this2, "setPlayerHeadPosition", function (pixelsFromLeft) {
      var timelineWidth = _this2.getTimelineWidth();
      var newPosition = function () {
        if (pixelsFromLeft < 0) {
          return 0;
        } else if (pixelsFromLeft > timelineWidth) {
          return timelineWidth;
        } else {
          return pixelsFromLeft;
        }
      }();
      _this2.setState({
        leftPosition: newPosition
      });
    });
    _defineProperty(_this2, "updateTimeline", function (e) {
      _this2.movePlayerHead(e);
      _this2.updateCurrentTime(_this2.state.duration * _this2.clickPercent(e));
    });
    _defineProperty(_this2, "clickPercent", function (e) {
      var timelineOffsets = _this2._timeLine.getBoundingClientRect();
      var timelineWidth = _this2.getTimelineWidth();
      return (e.pageX - timelineOffsets.left) / timelineWidth;
    });
    _defineProperty(_this2, "movePlayerHead", function (e) {
      var timelineOffsets = _this2._timeLine.getBoundingClientRect();
      var pixelsFromLeft = e.pageX - timelineOffsets.left;
      _this2.setPlayerHeadPosition(pixelsFromLeft);
    });
    _defineProperty(_this2, "isMovingPlayerHead", function () {
      _this2.setOnPlayerHead(true);
      window.addEventListener('mousemove', _this2.movePlayerHead, true);
      _this2._audio.removeEventListener('timeupdate', _this2.timeUpdate, false);
    });
    _defineProperty(_this2, "stoppedMovingPlayerHead", function (e) {
      var _this2$state = _this2.state,
        onPlayerHead = _this2$state.onPlayerHead,
        duration = _this2$state.duration;
      if (onPlayerHead) {
        _this2.movePlayerHead(e);
        window.removeEventListener('mousemove', _this2.movePlayerHead, true);
        _this2.updateCurrentTime(duration * _this2.clickPercent(e));
        _this2._audio.addEventListener('timeupdate', _this2.timeUpdate, false);
      }
      _this2.setOnPlayerHead(false);
    });
    _defineProperty(_this2, "setOnPlayerHead", function (stateValue) {
      _this2.setState({
        onPlayerHead: stateValue
      });
    });
    _defineProperty(_this2, "presentCurrentTime", function () {
      var currentTime = parseInt(_this2._audio ? _this2._audio.currentTime : 0);
      var duration = parseInt(_this2.state.duration);
      var diff = duration - currentTime;
      var date = moment('1970-01-01 00:00:00');
      var diffDuration = moment.duration(diff * 1000);
      var diffMoment = date.add(diffDuration);
      var hours = diffDuration.get('hours');
      return diffMoment.format(hours > 0 ? 'HH:mm:ss' : 'mm:ss');
    });
    return _this2;
  }
  _inherits(AudioPlayer, _BaseAudioPlayer2);
  return _createClass(AudioPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._audio.addEventListener('timeupdate', this.timeUpdate, false);
      this._progressBar.addEventListener('click', this.updateTimeline, false);
      this._playerHead.addEventListener('mousedown', this.isMovingPlayerHead, false);
      window.addEventListener('resize', this.timeUpdate, false);
      window.addEventListener('mouseup', this.stoppedMovingPlayerHead, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._audio.removeEventListener('timeupdate', this.timeUpdate, false);
      this._progressBar.removeEventListener('click', this.updateTimeline, false);
      this._playerHead.removeEventListener('mousedown', this.isMovingPlayerHead, false);
      window.removeEventListener('resize', this.timeUpdate, false);
      window.removeEventListener('mouseup', this.stoppedMovingPlayerHead, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        url = _this$props2.url,
        className = _this$props2.className;
      var _this$state = this.state,
        leftPosition = _this$state.leftPosition,
        isPlaying = _this$state.isPlaying;
      var i18next = this.context.i18next;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("audio", {
          ref: function ref(_ref) {
            return _this3._audio = _ref;
          },
          preload: "none",
          children: /*#__PURE__*/_jsx("source", {
            src: url
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex grow items-center gap-1",
          children: [/*#__PURE__*/_jsx("div", {
            className: twMerge('flex items-center rounded-sm bg-gray-200', className),
            children: isPlaying ? /*#__PURE__*/_jsx(IconButton, {
              "aria-label": i18next.t('action.pause'),
              className: "audio-player-pause",
              onClick: this.pause,
              children: /*#__PURE__*/_jsx(Icon, {
                iconKey: "pause",
                className: "text-gray-600"
              })
            }) : /*#__PURE__*/_jsx(IconButton, {
              onClick: this.play,
              tooltipLabel: i18next.t(i18next.t('Tooltip.Audio.Play')),
              className: "rounded-sm",
              children: /*#__PURE__*/_jsx(Icon, {
                iconKey: "play_arrow",
                className: "text-gray-600"
              })
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: twMerge('flex grow items-center gap-x-2 rounded-sm bg-gray-200 p-2', className),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "relative flex grow cursor-pointer items-center",
              ref: function ref(_ref4) {
                return _this3._progressBar = _ref4;
              },
              children: [/*#__PURE__*/_jsx("div", {
                className: twMerge('absolute h-1 w-full rounded-xs bg-gray-300', className),
                ref: function ref(_ref2) {
                  return _this3._timeLine = _ref2;
                }
              }), /*#__PURE__*/_jsx("div", {
                className: twMerge('absolute h-1 rounded-xs bg-gray-800', className),
                style: {
                  width: leftPosition
                }
              }), /*#__PURE__*/_jsx("div", {
                ref: function ref(_ref3) {
                  return _this3._playerHead = _ref3;
                }
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "shrink-0 text-center text-xs text-gray-500 tabular-nums",
              children: this.presentCurrentTime()
            })]
          })]
        })]
      });
    }
  }]);
}(BaseAudioPlayer);
_defineProperty(AudioPlayer, "propTypes", {
  handleMarkAsHandled: PropTypes.func,
  handleUnmarkAsHandled: PropTypes.func,
  className: PropTypes.string,
  onPlay: PropTypes.func
});
_defineProperty(AudioPlayer, "contextType", AppContext);
var MiniAudioPlayer = /*#__PURE__*/function (_BaseAudioPlayer3) {
  function MiniAudioPlayer() {
    var _this4;
    _classCallCheck(this, MiniAudioPlayer);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this4 = _callSuper(this, MiniAudioPlayer, [].concat(args));
    _defineProperty(_this4, "timeUpdate", function () {
      var duration = _this4.state.duration;
      var currentTime = _this4._audio.currentTime;
      if (currentTime >= duration) {
        _this4.stop();
      }
    });
    return _this4;
  }
  _inherits(MiniAudioPlayer, _BaseAudioPlayer3);
  return _createClass(MiniAudioPlayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.uniqueId !== this.props.uniqueId) {
        this.stop();
        this._audio.load();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._audio.addEventListener('timeupdate', this.timeUpdate, false);
      this._audio.addEventListener('durationchange', this.setDuration, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._audio.removeEventListener('timeupdate', this.timeUpdate, false);
      this._audio.removeEventListener('durationchange', this.setDuration, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var url = this.props.url;
      var isPlaying = this.state.isPlaying;
      var i18next = this.context.i18next;
      if (this._audio && this.props.uniqueId && this.props.uniqueId !== this.props.activeAudio) {
        this.stop();
      }
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("audio", {
          ref: function ref(_ref5) {
            return _this5._audio = _ref5;
          },
          preload: "none",
          children: /*#__PURE__*/_jsx("source", {
            src: url
          })
        }), /*#__PURE__*/_jsx("div", {
          children: isPlaying ? /*#__PURE__*/_jsx(IconButton, {
            onClick: this.stop,
            className: "size-10",
            "aria-label": i18next.t('Tooltip.Title.Stop'),
            children: /*#__PURE__*/_jsx(Icon, {
              iconKey: "stop",
              className: "text-red"
            })
          }) : /*#__PURE__*/_jsx(IconButton, {
            onClick: this.play,
            tooltipLabel: i18next.t('Tooltip.Audio.Play'),
            className: "text-red size-10",
            children: /*#__PURE__*/_jsx(Icon, {
              iconKey: "play_arrow",
              className: "text-gray-500"
            })
          })
        })]
      });
    }
  }]);
}(BaseAudioPlayer);
var AudioPlayerComponent = AudioPlayer;
var MiniAudioPlayerComponent = MiniAudioPlayer;
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeAudio: state.sounds.get('playSound')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    playSound: function playSound(id) {
      dispatch(_playSound(id));
    }
  };
};
var connectedMiniAudioPlayerComponent = connect(mapStateToProps, mapDispatchToProps)(MiniAudioPlayerComponent);
export { AudioPlayerComponent as AudioPlayer, connectedMiniAudioPlayerComponent as MiniAudioPlayer };